'use client';

import { SecurityDelete as Section } from '../../components/UserProfile/SecuritySections';
import { createSection } from '../createSection';

export const UserProfileDeleteSection = createSection('UserProfileDeleteSection', Section);
